"use client";

import { useCallback } from "react";
import { useRouter } from "next/navigation";
import { PATHNAME_HISTORY } from "~/lib/navigationEvents/NavigationEvents";

const useSafeBackNavigation = () => {
    const router = useRouter();

    return useCallback(() => {
        if (PATHNAME_HISTORY[PATHNAME_HISTORY.length-2]) {
            router.back();
        } else {
            router.push("/");
        }
    }, [router]);
};

export default useSafeBackNavigation;